// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 40,
  H_DESKTOP: 48,
  H_DESKTOP_OFFSET: 80 - 16,
};

export const NAV = {
  WIDTH: 270,
};

export const RADIUS = {
  BORDERRADIUS: 15,
};
